import { Menu } from "./models/menu";
import $ from "jquery";

export const menuList: Menu[] = [
    {
      label: 'common.home',
      cliqued: false,
      link: '/'
    },
    {
      label: 'common.my_projects',
      cliqued: false,
      link: '/products'
    },
    {
      label: 'common.blog',
      cliqued: false,
      link: '/blog'
    }
  ]

  export const showMenu = ()=>{
    $('.mobile-menu').css('display', 'block');
    $('.mobile-menu .mobile-menu-box').animate({
      right: 0,
    }, 300, ()=>{
    })
  }

  export const hideMenu = ()=>{
    if($('.mobile-menu').css('display') === 'block') $('.mobile-menu .mobile-menu-box').animate({
      right: -250,
    }, 300, ()=>{
      $('.mobile-menu').css('display', 'none');
    })
  }



